import React from "react";
import { Box, Typography } from "@mui/material";

function SectionHeading({ tag, title, number, mb = { xs: 3, md: 6 } }) {
  return (
    <Box sx={{ textAlign: "center", mb, position: "relative" }}>
      {number != null && (
        <Typography
          aria-hidden="true"
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            fontSize: { xs: "5rem", md: "8rem" },
            fontWeight: 900,
            color: "rgba(99,102,241,0.05)",
            lineHeight: 1,
            userSelect: "none",
            pointerEvents: "none",
            zIndex: 0,
            letterSpacing: "-0.05em",
            fontFamily: "monospace",
            whiteSpace: "nowrap",
          }}
        >
          {String(number).padStart(2, "0")}
        </Typography>
      )}
      <Box sx={{ position: "relative", zIndex: 1 }}>
        <Typography
          sx={{
            display: "block",
            color: "primary.light",
            fontFamily: "monospace",
            fontSize: "0.78rem",
            mb: 0.75,
            opacity: 0.5,
            letterSpacing: "0.1em",
          }}
        >
          {`<${tag} />`}
        </Typography>
        <Typography
          variant="h3"
          component="h2"
          sx={{
            fontSize: { xs: "1.75rem", sm: "2rem", md: "2.5rem" },
            background: "linear-gradient(135deg, #818cf8 0%, #22d3ee 100%)",
            backgroundClip: "text",
            WebkitBackgroundClip: "text",
            WebkitTextFillColor: "transparent",
            fontWeight: 700,
            lineHeight: 1.2,
          }}
        >
          {title}
        </Typography>
      </Box>
    </Box>
  );
}

export default SectionHeading;
